import { render, staticRenderFns } from "./UpSale.vue?vue&type=template&id=a9ab5dee&scoped=true&lang=pug"
import script from "./UpSale.vue?vue&type=script&lang=js"
export * from "./UpSale.vue?vue&type=script&lang=js"
import style0 from "./UpSale.vue?vue&type=style&index=0&id=a9ab5dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ab5dee",
  null
  
)

export default component.exports